export class EngagementScheduleModel {
  engagementId: number = null;
  acctYear: number = null;
  id: number = null;
  schedulesData: any;
  engagementDetails: any;
  scheduleOriginalData: any;
  leftSideMenu: any;
}
